var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{key:`pwa-web-ad-banner_${_vm.uniqueValue}_${_vm.adUnitId}_${_vm.adKey}`,ref:"adContainerWrapper",staticClass:"pwa-web-ad-banner"})
}
var staticRenderFns = []

export { render, staticRenderFns }